/**
 * Sentinel value for the "System default" row in the audio device pickers, which stands for
 * "no pin" in redux - the role follows whatever the OS currently considers the default.
 *
 * Deliberately not the empty string. MUI's Select hides the displayed value when it is empty
 * (SelectInput.js gates it behind `isFilled(value) || displayEmpty`), so an empty sentinel left
 * the closed field blank whenever the OS default was in use, even though the row was correctly
 * selected once the menu was open. A non-empty sentinel renders like any other option and cannot
 * collide with a real deviceId, which is always a hash or 'default' / 'communications'.
 *
 * Kept in its own module so it can be imported without pulling in the components barrel.
 */
// eslint-disable-next-line import/prefer-default-export
export const SYSTEM_DEFAULT = 'system-default';
